var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-hcaptcha',{attrs:{"sitekey":_vm.hcaptchaSitekey}})
}
var staticRenderFns = []

export { render, staticRenderFns }